"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Add = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var nucalm_1 = require("../../model/nucalm");
var service_1 = require("../../../library/base/service");
var Add = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Add, _super);
    function Add() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '新增预约';
        _this.code = '101203';
        _this.desc = '新增预约';
        _this.requestParams = new nucalm_1.NucalmRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Add;
}(service_1.BaseService));
exports.Add = Add;
//# sourceMappingURL=add.js.map